import { useState, useRef, useEffect } from "react";
import { Image, Placeholder } from "semantic-ui-react";

export default function Testimonials(props) {
  const imgRef = useRef(null);
  const [state, setState] = useState(false);

  const onImageLoaded = () => setState(true);

  useEffect(() => {
    const imgElCurrent = imgRef.current;

    if (imgElCurrent) {
      imgElCurrent.addEventListener("load", onImageLoaded);
      return () => imgElCurrent.removeEventListener("load", onImageLoaded);
    }
  }, [imgRef]);


  const { name, photo, testimony,position } = props;
  return (
    <div className={"social-cause-testimonial"}>
      <div className={"testimony-details"}>
        <Placeholder className={'testimony-photo'} style={{ display: state ? "none" : "block" }}>
          {/*<Placeholder.Image*/}
          {/*  as={"img"}*/}
          {/*  style={{ display: state ? "none" : "block" }}*/}
          {/*  className={"testimony-photo"}*/}
          {/*/>*/}
        </Placeholder>

        <Image
          onLoad={onImageLoaded}
          size={"medium"}
          src={photo}
          circular={true}
          className={"testimony-photo"}
          style={{ display: state ? "block" : "none" }}
        />
        <div className={'name'}>
          <p className={"name"}>{name}</p>
          <p className={'position'}>{position}</p>
        </div>

      </div>

      <p className={"testimony"}>{testimony}</p>
    </div>
  );
}
